import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PomodoroTimer from "@/components/pomodoro/PomodoroTimer";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { TrendingUp, LogIn } from "lucide-react";

export default function PomodoroPage() {
  const { user } = useAuth();

  useEffect(() => {
    document.title = "Pomodoro Timer - Habitualy";
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 py-8 md:py-12">
        <div className="container px-4 md:px-6">
          <div className="flex flex-col items-center space-y-4 text-center mb-8">
            <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
              Pomodoro Timer
            </h1>
            <p className="max-w-[700px] text-muted-foreground md:text-xl">
              Stay focused and productive with our beautiful Pomodoro timer. Work in focused intervals and take regular breaks.
            </p>
          </div>
          <div className="max-w-2xl mx-auto">
            <PomodoroTimer />
            
            {/* Subtle CTA */}
            <div className="mt-8 text-center">
              <p className="text-sm text-muted-foreground mb-3">
                Track your progress and build lasting habits
              </p>
              {user ? (
                <Button variant="outline" size="sm" asChild>
                  <Link to="/dashboard">
                    <TrendingUp className="h-4 w-4 mr-2" />
                    Go to Dashboard
                  </Link>
                </Button>
              ) : (
                <Button variant="outline" size="sm" asChild>
                  <Link to="/auth">
                    <LogIn className="h-4 w-4 mr-2" />
                    Sign Up Free
                  </Link>
                </Button>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
} 